document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('[data-slider]').forEach(slider => {
		const slides = slider.querySelectorAll(
			'.wp-block-image, .wp-block-video'
		);
		const dotsWrap = slider.querySelector('.sg-slider-dots');
		const autoplay = slider.dataset.autoplay === 'true';

		if (slides.length <= 1) return;

		let current = 0;
		let interval = null;

		// Dots erstellen
		slides.forEach((_, i) => {
			const dot = document.createElement('button');
			dot.addEventListener('click', () => goTo(i));
			dot.setAttribute("aria-label", "Bild Nummer " + (i + 1));
			dotsWrap.appendChild(dot);
		});

		const dots = dotsWrap.querySelectorAll('button');
		dots[0]?.classList.add('is-active');

		// Autoplay starten wenn aktiviert
		if (autoplay) {
			startAutoplay();

			// Autoplay pausieren bei Hover
			slider.addEventListener('mouseenter', stopAutoplay);
			slider.addEventListener('mouseleave', startAutoplay);

			// Auch bei Fokus auf Dots pausieren?
			dots.forEach(dot => {
				dot.addEventListener('mouseenter', stopAutoplay);
				dot.addEventListener('mouseleave', startAutoplay);
			});
		}

		function startAutoplay() {
			if (interval) clearInterval(interval);
			interval = setInterval(() => {
				const next = (current + 1) % slides.length;
				goTo(next);
			}, 3000); // 5 Sekunden
		}

		function stopAutoplay() {
			if (interval) {
				clearInterval(interval);
				interval = null;
			}
		}

		function goTo(index) {
			// Aktuellen Slide ausblenden
			slides[current].style.opacity = 0;
			dots[current]?.classList.remove('is-active');

			// Neuen Slide einblenden
			slides[index].style.opacity = 1;
			dots[index]?.classList.add('is-active');

			current = index;
		}
	});
});
